import { ReactNode } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import classNames from 'classnames';
import styles from './Toggle.module.scss';
import TestIds from '../../tests/TestIds';

interface ToggleProps {
	id: string;
	name: string;
	disabled?: boolean;
	checked: boolean;
	onChange?: any;
	value?: string;
	label?: MessageDescriptor;
	className?: string;
	labelClassName?: string;
	children?: ReactNode;
}

const Toggle = ({
	id,
	name,
	disabled = false,
	checked,
	onChange,
	value,
	label,
	className,
	labelClassName,
	children,
}: ToggleProps) => {
	const { formatMessage } = useIntl();
	return (
		<label
			htmlFor={id}
			className={classNames(styles.field, className, { [styles.disabled]: disabled })}
		>
			{children && children}
			{label && (
				<span className={classNames(styles.label, labelClassName)}>
					{formatMessage(label)}
				</span>
			)}
			<div className={styles.toggle}>
				<input
					data-cy={TestIds.Toggle}
					type="checkbox"
					checked={checked}
					className={styles.checkbox}
					disabled={disabled}
					id={id}
					name={name}
					onChange={onChange}
					value={value}
				/>
				<div className={styles.slider} />
			</div>
		</label>
	);
};

export default Toggle;
